import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFigmaXs = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5 4V9M12.5 4H10C8.61929 4 7.5 5.11929 7.5 6.5V6.5C7.5 7.88071 8.61929 9 10 9H12.5M12.5 4H15C16.3807 4 17.5 5.11929 17.5 6.5V6.5C17.5 7.88071 16.3807 9 15 9H12.5",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5 16.5V14H10C8.61929 14 7.5 15.1193 7.5 16.5C7.5 17.8807 8.61929 19 10 19C11.3807 19 12.5 17.8807 12.5 16.5Z",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5 9V14M12.5 9H10C8.61929 9 7.5 10.1193 7.5 11.5V11.5C7.5 12.8807 8.61929 14 10 14H12.5M12.5 9H15C16.3807 9 17.5 10.1193 17.5 11.5V11.5C17.5 12.8807 16.3807 14 15 14H12.5",
			stroke: "currentColor",
			strokeWidth: 2
		})
	]
});
export default SvgFigmaXs;
